import React from 'react'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { FieldValues } from '../IMSFormFieldsTypes'

interface Component {
    id: React.Key | null | undefined
    label_display: any
    label: any
    is_auto_populated?: boolean
    component_response?: { value: any }
    datatype: string
}

interface Group {
    id: React.Key | null | undefined
}

interface IMSFormAccordionNumberFieldProps {
    component: Component
    group: Group
    fieldValues: FieldValues
    handleFieldChange: (
        groupId: string | number,
        componentId: string | number,
        value: any,
        datatype: string
    ) => void
    shouldShowAutoPopulatedIndicator: (
        component: any,
        fieldValues: FieldValues
    ) => boolean
}

const IMSFormAccordionNumberField: React.FC<
    IMSFormAccordionNumberFieldProps
> = ({
    component,
    group,
    fieldValues,
    handleFieldChange,
    shouldShowAutoPopulatedIndicator,
}) => {
    console.log({
        component,
        group,
        fieldValues,
    })
    const AutoPopulateIndicator = () => (
        <FiberManualRecordIcon
            sx={{
                position: 'absolute',
                left: -30,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#209b2e',
                fontSize: '20px',
            }}
            titleAccess="Auto-populated from VIN"
        />
    )

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            {typeof component.id === 'number' &&
                shouldShowAutoPopulatedIndicator(
                    {
                        is_auto_populated: component.is_auto_populated,
                        id: component.id as number,
                        component_response: component.component_response,
                    },
                    fieldValues
                ) && <AutoPopulateIndicator />}
            <input
                type="text"
                style={{
                    width: '100%',
                    padding: '5px',
                    border: '1px solid #ccc',
                    borderRadius: '3px',
                    margin: '10px 0',
                }}
                inputMode="numeric"
                pattern="[0-9]*"
                value={
                    component.id != null
                        ? typeof fieldValues[String(component.id)]?.value !==
                          'undefined'
                            ? fieldValues[String(component.id)].value
                            : fieldValues[String(component.id)] || ''
                        : ''
                }
                onChange={(event) => {
                    if (group.id != null && component.id != null) {
                        const raw = event.target.value
                        const cleaned = raw.replace(/\D+/g, '')
                        handleFieldChange(
                            String(group.id),
                            String(component.id),
                            cleaned,
                            component.datatype
                        )
                    }
                }}
            />
        </div>
    )
}

export default IMSFormAccordionNumberField
